// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import React, { useContext, useEffect, useRef, useState } from "react";
import { ImageMaskState, ToolProps } from "../../../helpers/Interfaces";
import * as _ from "underscore";
import DesignHubContext from "../../../components/hooks/DesignHub/createContext";
import { checkIsProcessingState, isCurrentImageMaskState } from "../../../components/helpers/maskUtils";
import { Spinner } from "reactstrap";
import { I18n } from "aws-amplify";

const ImageTool = () => {
    const {
        image: [image,],
        maskImageState: [maskImageState, setMaskImageState],
        isLoading: [isLoading, setIsLoading],
    } = useContext(DesignHubContext)!;

    const [isAllowSelection, setIsAllowSelection] = useState<boolean>(true);

    // const [isLoading, setIsLoading] = useState<boolean>(true);

    const imageClasses = "img-thumbnail d-block";
    const maskImageClasses = `absolute opacity-80 pointer-events-none img-thumbnail top-0 d-block`;

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 600);
        return () => clearTimeout(timer);
    }, []);


    const imageRef = useRef<any>(null);

    const handleClickOutside = (event: any) => {
        function eventHasId(id: string) {
            return event.target.id === id;
        }
        if (imageRef.current && !imageRef.current.contains(event.target) &&
            (eventHasId("imageWrapper") || eventHasId("deselect"))) {
            setIsAllowSelection(true);
            setMaskImageState(ImageMaskState.Select);
        } else {
            setIsAllowSelection(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);


    function isProcessing() {
        return checkIsProcessingState(maskImageState);
    }

    // Render the image and the predicted mask image on top
    return (
        <>
            {image && (
                <img
                    id={"designImage"}
                    ref={imageRef}
                    src={image.src}
                    className={`${imageClasses}
                    ${isProcessing() ?
                            " animate-pulse" : ""
                        }`
                    }
                ></img >
            )}
            {
                !image && isLoading &&
                <p className="text-lg"> {I18n.get("loading")}
                </p>
            }
            {!image && !isLoading && <p className="text-lg"> {I18n.get("no_images_found")}  </p>}
            {
                isProcessing() &&
                <div className="absolute inset-0 flex justify-center items-center z-10">
                    <Spinner className="ms-2 absolute" color="primary" />
                </div>
            }
        </>
    );
};

export default ImageTool;
